import { Routes, Route } from 'react-router-dom'
import { useAuthStore } from '@/stores/authStore'
import { BrandingProvider } from '@/contexts/BrandingContext'
import { useEffect } from 'react'
import AuthLayout from '@/components/layouts/AuthLayout'
import HomeLayout from '@/components/layouts/HomeLayout'
import DashboardLayout from '@/components/layouts/DashboardLayout'
import Home from '@/pages/Home'
import Dashboard from '@/pages/Dashboard'
import Transactions from '@/pages/Transactions'
import SaleShops from '@/pages/SaleShops'
import Customers from '@/pages/Customers'
import Analytics from '@/pages/Analytics'
import System from '@/pages/System'
import Audit from '@/pages/Audit'
import Settings from '@/pages/Settings'
import Notifications from '@/pages/Notifications'
import ProtectedRoute from '@/components/ProtectedRoute'
import Login from './pages/Login'
import MerchantRegister from './pages/MerchantRegister'
import CreateSaleShop from './pages/CreateSaleShop'
import SaleShopDetail from './pages/SaleShopDetail'
import About from './pages/About'
import Terms from './pages/Terms'
import Contact from './pages/Contact'
import FAQ from './pages/FAQ'
import Privacy from './pages/Privacy'
import DeveloperCommunity from './pages/DeveloperCommunity'
import HelpCenter from './pages/HelpCenter'
import APIDocumentations from './pages/APIDocumentations'
import PaymentLinks from './pages/PaymentLinks'
import { Documents } from './pages/Documents'
import { AdminDocuments } from './pages/AdminDocuments'
import TransactionDetail from './pages/TransactionDetail'
import AdminSaleChannels from './pages/AdminSaleChannels'
import AdminCreateSaleChannel from './pages/AdminCreateSaleChannel'
import AdminCreateUser from './pages/AdminCreateUser'
import AdminEditUser from './pages/AdminEditUser'
import AdminUserList from './pages/AdminUserList'
import AdminUserDetail from './pages/AdminUserDetail'
import AdminMerchantList from './pages/AdminMerchantList'
import MerchantDetails from './pages/MerchantDetails'
import MerchantUsersList from './pages/MerchantUsersList'
import AdminPayoutManagement from './pages/AdminPayoutManagement'
import AdminPayoutBatchesList from './pages/AdminPayoutBatchesList'
import AdminPayoutBatchDetail from './pages/AdminPayoutBatchDetail'
import AdminPayoutBatchForm from './pages/AdminPayoutBatchForm'
import AdminSettlementsList from './pages/AdminSettlementsList'
import AdminSettlementDetail from './pages/AdminSettlementDetail'
import AdminSettlementForm from './pages/AdminSettlementForm'
import AdminSettlementItemsList from './pages/AdminSettlementItemsList'
import AdminCommissionRecordsList from './pages/AdminCommissionRecordsList'
import PaginationTest from './pages/PaginationTest'
import AdminWhiteLabelDomains from './pages/admin/AdminWhiteLabelDomains'
import WhiteLabelDomains from './pages/settings/WhiteLabelDomains'

function App() {
  const { checkAuth, user } = useAuthStore()

  useEffect(() => {
    checkAuth()
  }, [checkAuth])

  return (
    <BrandingProvider user={user || undefined}>
      <Routes>
        {/* Public routes with HomeLayout */}
        <Route
          path="/"
          element={
            <HomeLayout>
              <Home />
            </HomeLayout>
          }
        />

        <Route
          path="/about"
          element={
            <HomeLayout>
              <About />
            </HomeLayout>
          }
        />

        <Route
          path="/terms"
          element={
            <HomeLayout>
              <Terms />
            </HomeLayout>
          }
        />

        <Route
          path="/contact"
          element={
            <HomeLayout>
              <Contact />
            </HomeLayout>
          }
        />

        <Route
          path="/faq"
          element={
            <HomeLayout>
              <FAQ />
            </HomeLayout>
          }
        />

        <Route
          path="/privacy"
          element={
            <HomeLayout>
              <Privacy />
            </HomeLayout>
          }
        />

        <Route
          path="/developer-community"
          element={
            <HomeLayout>
              <DeveloperCommunity />
            </HomeLayout>
          }
        />

        <Route
          path="/help-center"
          element={
            <HomeLayout>
              <HelpCenter />
            </HomeLayout>
          }
        />

        <Route
          path="/documentations"
          element={<APIDocumentations />}
        />

        <Route
          path="/pagination-test"
          element={
            <HomeLayout>
              <PaginationTest />
            </HomeLayout>
          }
        />

        {/* Auth routes with AuthLayout */}
        <Route
          path="/login"
          element={
            <AuthLayout>
              <Login />
            </AuthLayout>
          }
        />

        <Route
          path="/register"
          element={
            <AuthLayout>
              <MerchantRegister />
            </AuthLayout>
          }
        />

        {/* Protected dashboard routes with DashboardLayout */}
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <DashboardLayout>
                <Dashboard />
              </DashboardLayout>
            </ProtectedRoute>
          }
        />

        {/* Business Management Routes */}
        <Route
          path="/transactions"
          element={
            <ProtectedRoute>
              <DashboardLayout>
                <Transactions />
              </DashboardLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/transactions/:id"
          element={
            <ProtectedRoute>
              <DashboardLayout>
                <TransactionDetail />
              </DashboardLayout>
            </ProtectedRoute>
          }
        />

        {/* payment links routes */}
        <Route
          path="/payment-links"
          element={
            <ProtectedRoute>
              <DashboardLayout>
                <PaymentLinks />
              </DashboardLayout>
            </ProtectedRoute>
          }
        />
        {/* sale shops routes */}
        <Route
          path="/sale-shops"
          element={
            <ProtectedRoute>
              <DashboardLayout>
                <SaleShops />
              </DashboardLayout>
            </ProtectedRoute>
          }
        />

        {/* create sale shop route */}
        <Route
          path="/sale-shops/create"
          element={
            <ProtectedRoute>
              <DashboardLayout>
                <CreateSaleShop />
              </DashboardLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/sale-shops/:id"
          element={
            <ProtectedRoute>
              <DashboardLayout>
                <SaleShopDetail />
              </DashboardLayout>
            </ProtectedRoute>
          }
        />

        {/* customers route */}
        <Route
          path="/customers"
          element={
            <ProtectedRoute>
              <DashboardLayout>
                <Customers />
              </DashboardLayout>
            </ProtectedRoute>
          }
        />

        {/* Analytics Routes */}
        <Route
          path="/analytics"
          element={
            <ProtectedRoute>
              <DashboardLayout>
                <Analytics />
              </DashboardLayout>
            </ProtectedRoute>
          }
        />

        {/* System Management Routes */}
        <Route
          path="/system"
          element={
            <ProtectedRoute>
              <DashboardLayout>
                <System />
              </DashboardLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/audit"
          element={
            <ProtectedRoute>
              <DashboardLayout>
                <Audit />
              </DashboardLayout>
            </ProtectedRoute>
          }
        />
        {/* Settings Routes with nested routing */}
        <Route
          path="/settings/*"
          element={
            <ProtectedRoute>
              <DashboardLayout>
                <Settings />
              </DashboardLayout>
            </ProtectedRoute>
          }
        />

        {/* Notifications Route */}
        <Route
          path="/notifications"
          element={
            <ProtectedRoute>
              <DashboardLayout>
                <Notifications />
              </DashboardLayout>
            </ProtectedRoute>
          }
        />

        {/* Document Management Routes */}
        <Route
          path="/documents"
          element={
            <ProtectedRoute>
              <DashboardLayout>
                <Documents />
              </DashboardLayout>
            </ProtectedRoute>
          }
        />

        {/* Admin Document Management Route */}
        <Route
          path="/admin/documents"
          element={
            <ProtectedRoute>
              <DashboardLayout>
                <AdminDocuments />
              </DashboardLayout>
            </ProtectedRoute>
          }
        />

        {/* Admin Sale Channels Management Routes */}
        <Route
          path="/admin/sale-channels"
          element={
            <ProtectedRoute>
              <DashboardLayout>
                <AdminSaleChannels />
              </DashboardLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/sale-channels/create"
          element={
            <ProtectedRoute>
              <DashboardLayout>
                <AdminCreateSaleChannel />
              </DashboardLayout>
            </ProtectedRoute>
          }
        />

        {/* Admin User Management Routes */}
        <Route
          path="/admin/users"
          element={
            <ProtectedRoute>
              <DashboardLayout>
                <AdminUserList />
              </DashboardLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/users/create"
          element={
            <ProtectedRoute>
              <DashboardLayout>
                <AdminCreateUser />
              </DashboardLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/users/:id/edit"
          element={
            <ProtectedRoute>
              <DashboardLayout>
                <AdminEditUser />
              </DashboardLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/users/:id"
          element={
            <ProtectedRoute>
              <DashboardLayout>
                <AdminUserDetail />
              </DashboardLayout>
            </ProtectedRoute>
          }
        />

        {/* Admin Merchant Management Routes */}
        <Route
          path="/admin/merchants"
          element={
            <ProtectedRoute>
              <DashboardLayout>
                <AdminMerchantList />
              </DashboardLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/merchants/create"
          element={
            <ProtectedRoute>
              <DashboardLayout>
                <AdminCreateUser />
              </DashboardLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/merchants/:id"
          element={
            <ProtectedRoute>
              <DashboardLayout>
                <AdminUserDetail />
              </DashboardLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/merchants/:id/edit"
          element={
            <ProtectedRoute>
              <DashboardLayout>
                <AdminCreateUser />
              </DashboardLayout>
            </ProtectedRoute>
          }
        />

        {/* Merchant Management Routes (for merchant_admin) */}
        <Route
          path="/merchant/details"
          element={
            <ProtectedRoute>
              <DashboardLayout>
                <MerchantDetails />
              </DashboardLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/merchant/details/edit"
          element={
            <ProtectedRoute>
              <DashboardLayout>
                <AdminCreateUser />
              </DashboardLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/merchant/users"
          element={
            <ProtectedRoute>
              <DashboardLayout>
                <MerchantUsersList />
              </DashboardLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/merchant/users/create"
          element={
            <ProtectedRoute>
              <DashboardLayout>
                <AdminCreateUser />
              </DashboardLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/merchant/users/:id"
          element={
            <ProtectedRoute>
              <DashboardLayout>
                <AdminUserDetail />
              </DashboardLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/merchant/users/:id/edit"
          element={
            <ProtectedRoute>
              <DashboardLayout>
                <AdminCreateUser />
              </DashboardLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/merchant/submerchants"
          element={
            <ProtectedRoute>
              <DashboardLayout>
                <AdminSaleChannels />
              </DashboardLayout>
            </ProtectedRoute>
          }
        />

        {/* Admin Payout Management Routes */}
        <Route
          path="/admin/payouts"
          element={
            <ProtectedRoute>
              <DashboardLayout>
                <AdminPayoutManagement />
              </DashboardLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/payout-batches"
          element={
            <ProtectedRoute>
              <DashboardLayout>
                <AdminPayoutBatchesList />
              </DashboardLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/payout-batches/create"
          element={
            <ProtectedRoute>
              <DashboardLayout>
                <AdminPayoutBatchForm />
              </DashboardLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/payout-batches/:id"
          element={
            <ProtectedRoute>
              <DashboardLayout>
                <AdminPayoutBatchDetail />
              </DashboardLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/payout-batches/:id/edit"
          element={
            <ProtectedRoute>
              <DashboardLayout>
                <AdminPayoutBatchForm />
              </DashboardLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/settlements"
          element={
            <ProtectedRoute>
              <DashboardLayout>
                <AdminSettlementsList />
              </DashboardLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/settlements/create"
          element={
            <ProtectedRoute>
              <DashboardLayout>
                <AdminSettlementForm />
              </DashboardLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/settlements/:id"
          element={
            <ProtectedRoute>
              <DashboardLayout>
                <AdminSettlementDetail />
              </DashboardLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/settlements/:id/edit"
          element={
            <ProtectedRoute>
              <DashboardLayout>
                <AdminSettlementForm />
              </DashboardLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/settlement-items/:settlementId"
          element={
            <ProtectedRoute>
              <DashboardLayout>
                <AdminSettlementItemsList />
              </DashboardLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/commission-records"
          element={
            <ProtectedRoute>
              <DashboardLayout>
                <AdminCommissionRecordsList />
              </DashboardLayout>
            </ProtectedRoute>
          }
        />
        {/* White Label Domains Routes */}
        <Route
          path="/admin/white-label-domains"
          element={
            <ProtectedRoute>
              <DashboardLayout>
                <AdminWhiteLabelDomains />
              </DashboardLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/settings/white-label-domains"
          element={
            <ProtectedRoute>
              <DashboardLayout>
                <WhiteLabelDomains />
              </DashboardLayout>
            </ProtectedRoute>
          }
        />
      </Routes>
    </BrandingProvider>
  )
}

export default App
